<template>
  <div>
    <div v-for="m in markets" v-if="selected.includes(m.market)">
      <div style="display: none;" class="EventCardItem-styles-market-title"></div>
      <div class="EventCardItem-styles-flex-container">
        <button v-for="s in m.odd" v-on:click="addBet(s, m)" :class="'odd-c-'+s.id" class="EventOddButton-styles-odd-button EventOddButton-styles-event-card-odd-button EventOddButton-styles-first-button">
          <div class="EventOddButton-styles-odd-caption EventOddButton-styles-event-card-odd-caption">
            {{ s.outcome }}
          </div>
          <span>{{ s.odd }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import market from '@/components/sportsbook/market/market';
export default {
  name: 'cardMarket',
  props: ['markets', 'selected', 'match'],
  components: {market},
  data () {
    return {

    }
  },
  methods: {
    addBet (bet, market) {
      this.$bus.$emit('betAdd', {bet: bet, market: market, match: this.match});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.EventCardItem-styles-card-wrapper .EventCardItem-styles-market-title {
  text-align: center;
}
.EventOddButton-styles-event-card-odd-button {
  margin: 0 0 0 3px;
}

.active-odd-button {
  background-color: var(--blue-dark);
  color: var(--white);
  border-color: var(--blue-dark);
}
.active-odd-button > .EventOddButton-styles-odd-caption {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/market/cardMarket.vue